
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SingleSelectGraphTypeV1 {
  export enum SingleSelectGraphTypeV1 {
    DONUT = "DONUT",
    PIE = "PIE",
    HORIZONTAL_BAR = "HORIZONTAL_BAR",
    VERTICAL_BAR = "VERTICAL_BAR",
    LINE = "LINE",
    LINE_AREA = "LINE_AREA",
    NONE = "NONE",
  }

  export interface SingleSelectGraphTypeV1DTO {
    case: string;
  }

  export const fromDTO = (dto: SingleSelectGraphTypeV1DTO): SingleSelectGraphTypeV1 => {
    if (dto === undefined || dto === null) {
      throw new InvalidSingleSelectGraphTypeV1Error(
        `Invalid DTO ${dto} provided for SingleSelectGraphTypeV1.SingleSelectGraphTypeV1`
      );
    }
    switch (dto.case) {
      case "DONUT":
        return SingleSelectGraphTypeV1.DONUT;
      case "PIE":
        return SingleSelectGraphTypeV1.PIE;
      case "HORIZONTAL_BAR":
        return SingleSelectGraphTypeV1.HORIZONTAL_BAR;
      case "VERTICAL_BAR":
        return SingleSelectGraphTypeV1.VERTICAL_BAR;
      case "LINE":
        return SingleSelectGraphTypeV1.LINE;
      case "LINE_AREA":
        return SingleSelectGraphTypeV1.LINE_AREA;
      case "NONE":
        return SingleSelectGraphTypeV1.NONE;
      default:
        throw new InvalidSingleSelectGraphTypeV1Error(
          `Case ${dto.case} is not valid case of SingleSelectGraphTypeV1.SingleSelectGraphTypeV1`
        );
    }
  };

  export const toDTO = (singleSelectGraphTypeV1: SingleSelectGraphTypeV1): SingleSelectGraphTypeV1DTO => {
    const enumDTO = {
      case: SingleSelectGraphTypeV1[singleSelectGraphTypeV1],
    };
    return enumDTO;
  };
}

export class InvalidSingleSelectGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectGraphTypeV1Error";
  }
}
export class InvalidSingleSelectGraphTypeV1DonutError extends InvalidSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectGraphTypeV1DonutError";
  }
}

export class InvalidSingleSelectGraphTypeV1PieError extends InvalidSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectGraphTypeV1PieError";
  }
}

export class InvalidSingleSelectGraphTypeV1HorizontalBarError extends InvalidSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectGraphTypeV1HorizontalBarError";
  }
}

export class InvalidSingleSelectGraphTypeV1VerticalBarError extends InvalidSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectGraphTypeV1VerticalBarError";
  }
}

export class InvalidSingleSelectGraphTypeV1LineError extends InvalidSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectGraphTypeV1LineError";
  }
}

export class InvalidSingleSelectGraphTypeV1LineAreaError extends InvalidSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectGraphTypeV1LineAreaError";
  }
}

export class InvalidSingleSelectGraphTypeV1NoneError extends InvalidSingleSelectGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectGraphTypeV1NoneError";
  }
}
